import * as React from 'react';
import { format } from '@websky/core/src/utils';

interface Props {
	dateTo: Date;
	dateBack?: boolean;
	isOpen?: boolean;
}

const DatepickerValue: React.FC<Props> = ({ dateTo, dateBack, isOpen }) => {
	return <>{format(dateTo, 'eeeeee')}</>;
};

export default DatepickerValue;
